module.exports = __webpack_public_path__ + "img/glowEss2.d26f458f.png";